import React from 'react';
import Launch_empty_stateDF from '../components/SimulatorsComponents/DefualtSimulators/Launch_empty_stateDF';

//= ========================================================================
const Sim_T05_Launch_empty_state = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <Launch_empty_stateDF
    globJSON={globJSON}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_T05_Launch_empty_state;
